const LoadingSpinnerInline = () => (
  <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full" />
);

export default LoadingSpinnerInline;
